import { defineMessages } from 'react-intl';

export const inlineEditBarMessages = defineMessages({
  generating: {
    defaultMessage: 'Heidi is thinking…',
    id: 'CBiOVlqEip',
    description: 'Rotating status label while an inline AI edit is being generated',
  },
  generatingReading: {
    defaultMessage: 'Reading your note…',
    id: '3gOvp0F8bP',
    description: 'Rotating status label while an inline AI edit is being generated',
  },
  generatingDrafting: {
    defaultMessage: 'Drafting the edit…',
    id: 'cbt3EjPhPX',
    description: 'Rotating status label while an inline AI edit is being generated',
  },
  generatingPolishing: {
    defaultMessage: 'Polishing the wording…',
    id: 'ZZK9NbjA1k',
    description: 'Rotating status label while an inline AI edit is being generated',
  },
  generatingGathering: {
    defaultMessage: 'Gathering evidence…',
    id: 'z6PBeyQw4s',
    description: 'Rotating status label while an inline insight is being generated',
  },
  generatingSummarising: {
    defaultMessage: 'Pulling out the key points…',
    id: '7STjdORO3C',
    description: 'Rotating status label while an inline insight is being generated',
  },
  stop: {
    defaultMessage: 'Cancel',
    id: 'rh7wnV1gSM',
    description: 'Button that cancels an in-progress inline AI edit',
  },
  accept: {
    defaultMessage: 'Accept',
    id: 't6P/+eANJj',
    description: 'Button that applies the inline AI edit to the note',
  },
  insertBelow: {
    defaultMessage: 'Insert below',
    id: '+/2JIOFMvX',
    description:
      'Icon button that keeps the original text and adds the AI edit underneath it',
  },
  discard: {
    defaultMessage: 'Discard',
    id: 'qj7/44STMA',
    description: 'Button that rejects the inline AI edit, leaving the note unchanged',
  },
  undo: {
    defaultMessage: 'Undo',
    // eslint-disable-next-line formatjs/enforce-id -- description-only change; keep the catalog ids. Remove this disable if a defaultMessage changes.
    id: 'LtPoXw0A4g',
    description:
      'Icon button that drops the proposed inline AI edit and closes the edit bar, leaving the note unchanged',
  },
  goodResponse: {
    defaultMessage: 'Good response',
    id: 'z/GronCpWm',
    description:
      'Thumbs-up button that records positive feedback on an inline AI response',
  },
  badResponse: {
    defaultMessage: 'Bad response',
    id: '257MtddVlK',
    description:
      'Thumbs-down button that records negative feedback on an inline AI response',
  },
  close: {
    defaultMessage: 'Close',
    id: 'LUyJgAorQg',
    description: 'Primary button that closes the inline View transcript insight panel',
  },
  viewInTranscript: {
    defaultMessage: 'View in transcript',
    id: 'RVI7N/eqI3',
    description:
      'Secondary button that opens the Transcript tab and highlights the excerpts from an inline View transcript insight',
  },
  dismiss: {
    defaultMessage: 'Dismiss',
    id: 'TvFM2VnWlF',
    description: 'Icon button that closes the inline insight panel',
  },
  couldNotAnswer: {
    defaultMessage: 'Heidi couldn’t answer this here',
    id: 'PpfgksOtNI',
    description: 'Panel label when the inline response could not answer the question',
  },
  copy: {
    defaultMessage: 'Copy',
    id: '5dChNbJ0ls',
    description: 'Icon button that copies the inline AI response to the clipboard',
  },
  askInChat: {
    defaultMessage: 'Start a chat',
    id: 'UOxqjur7i/',
    description:
      'Button that re-asks the question in the Evidence chat panel when the inline response could not answer',
  },
  promptPlaceholder: {
    defaultMessage: 'What would you like to change?',
    id: 'L8pMqdw2GV',
    description: 'Placeholder of the lite prompt input under the highlighted text',
  },
  send: {
    defaultMessage: 'Send',
    id: 'uU2nS4wSyO',
    description: 'Accessible name for the lite prompt input submit button',
  },
});
